import { useState, useEffect } from 'react';
import HeroLeft from './HeroLeft';
import HeroRight from './HeroRight';

export default function HeroSection({ onSignup }) {
  const [leftVisible, setLeftVisible] = useState(false);
  const [rightVisible, setRightVisible] = useState(false);
  const [startDemo, setStartDemo] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setLeftVisible(true), 120);
    const t2 = setTimeout(() => setRightVisible(true), 500);
    const t3 = setTimeout(() => setStartDemo(true), 880);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  return (
    <div id="hero-section">
      <main className="hero">
        <HeroLeft leftVisible={leftVisible} onSignup={onSignup} />
        <HeroRight rightVisible={rightVisible} startDemo={startDemo} />
      </main>
    </div>
  );
}
